<article class="sizeOfPrizeComparison">
  <div class="header">
    <h2  *ngIf="!isFreemium">Spending Ranking</h2>
    <h2  *ngIf="isFreemium">Future Demand Ranking</h2>
    <h3>
      {{ dataFilters.regionSelection.getName() }} - {{ dataFilters.year }}
    </h3>
    <mpro-tags style="margin: 15px 0px"></mpro-tags>
    <mpro-accordion title="About this module" [primary]="true">
      <p>
        This module presents the annual spending, by countries, in the current
        year against the year and the target group base on your selections
        above.
      </p>
    </mpro-accordion>
  </div>
  <mpro-region-comparison-table
    [isFromSizeOfPrize]="true"
    [countries]="tableData"
    [selectedYear]="dataFilters.year"
  ></mpro-region-comparison-table>
</article>
